import type { BasketballMatchModel } from '@nf/types/odds';
import { PeriodScoresBase } from '../period-scores.base';

export class BasketballPeriodScores extends PeriodScoresBase<BasketballMatchModel> {
	createPeriodScores(): Array<string> {
		if (!this.match.ls) {
			return [];
		}

		const { h1q, h2q, h3q, h4q, a1q, a2q, a3q, a4q, llp } = this.match.ls;

		const quarterScores = [
			`${h1q}-${a1q}`,
			`${h2q}-${a2q}`,
			`${h3q}-${a3q}`,
			`${h4q}-${a4q}`
		];
		
		return quarterScores.slice(0, Number(llp));
	}
}